const Ssn = Object.freeze({
  NAME: 'start',
  PAGE_SUBFUNCTION: 'ssn verify',
  MESSAGE_KEY: 'default'
})

export default Ssn
